// Client-side, no-page-reload fetch of an athlete's personal records for an
// arbitrary date range — mirrors js/load/workout-stats.js's own
// "dayPersonalRecords" query construction exactly. Powers Nutrition
// Progress's on-demand history extension (useExtendedHistoryData) when the
// coach picks a range older than what the initial page load fetched
// (nutrition.controller.js caps dayPersonalRecords to a trailing 1-year
// window). Same isAfterToday(end) bail as the loader — see date-helpers.js.

import { isAfterToday } from "../utils/date-helpers";
import { jsonGetRoute } from "./json-get-route";

const PersonalRecords = (app) => {
  app.get(
    "/personal-records",
    jsonGetRoute(
      ({ req }) => {
        const { start, end, proxyAthlete, isCheckIn } = req.query || {};
        if (isAfterToday(end)) return null;

        const query = { start, end, isCheckIn };
        if (proxyAthlete) query.proxyAthlete = proxyAthlete;
        return ["personal-records", { query }];
      },
      (data) => data ?? {}
    )
  );
};

export default PersonalRecords;
